import React from 'react';

const IconToggleOn: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    stroke='currentColor'
    fill='none'
    viewBox='0 0 576 512'
    height='16'
    width='16'
    focusable='false'
    role='presentation'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    className={`icon icon-toggle-on${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z'
      fill=''
    ></path>
  </svg>
);
export default IconToggleOn;
